<div class="topic-collapsible">
  <div class="topic-content">
    <div class="border-bottom-lna">
      <div class="lna-row">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.readersCard.purpose' | translate }}
          </p>
          <p class="form-value">
            {{ 'pages.client.readersCard.' + topic.purpose | translate }}
          </p>
        </div>
      </div>
      @if (topic.purpose === 'WorkTask') {
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.workplaceRegistrationNumber' | translate }}
            </p>
            <p class="form-value">{{ topic.work?.registrationNumber }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.workplaceName' | translate }}
            </p>
            <p class="form-value">{{ topic.work?.name }}</p>
          </div>
        </div>
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.workplaceEmail' | translate }}
            </p>
            <p class="form-value">{{ topic.work?.email }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.workplacePhone' | translate }}
            </p>
            <p class="form-value">{{ topic.work?.phone }}</p>
          </div>
        </div>
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.workplaceAddress' | translate }}
            </p>
            <p class="form-value">{{ topic.work?.address }}</p>
          </div>
        </div>
      }
      @if (topic.purpose === 'StudyResearch') {
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.studyRegistrationNumber' | translate }}
            </p>
            <p class="form-value">{{ topic.study?.registrationNumber }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.studyName' | translate }}
            </p>
            <p class="form-value">{{ topic.study?.name }}</p>
          </div>
        </div>
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.studyFaculty' | translate }}
            </p>
            <p class="form-value">{{ topic.study?.faculty }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.studyAddress' | translate }}
            </p>
            <p class="form-value">{{ topic.study?.address }}</p>
          </div>
        </div>
      }
    </div>
    <div class="lna-row full-width">
      <div class="value-wrapper">
        <p class="form-label">
          {{ 'pages.client.readersCard.chronologicalBoundaries' | translate }}
        </p>
        <p class="form-value">{{ topic.chronologicalBoundaries }}</p>
      </div>
    </div>
    <div class="lna-row full-width">
      <div class="value-wrapper">
        <p class="form-label">
          {{ 'pages.client.readersCard.researchGoalAndAccessReason' | translate }}
        </p>
        <p class="form-value">{{ topic.researchGoalAndAccessReason }}</p>
      </div>
    </div>
    <div class="lna-row full-width">
      <div class="value-wrapper">
        <p class="form-label">
          {{ 'pages.client.readersCard.researchNotes' | translate }}
        </p>
        <p class="form-value">{{ topic.notes || '-' }}</p>
      </div>
    </div>
    <div class="lna-row full-width">
      <div class="value-wrapper">
        <div class="label-wrapper">
        <p class="form-label">
          {{ 'pages.client.readersCard.addedFiles' | translate }}
        </p>
        @if (fromServiceSummary){<app-tooltip text="topicAddedFiles" />}</div>
        <app-file-upload
          [isEditMode]="false"
          [existingFiles]="getTopicFiles() || []"
          [associatedEntityId]="topic.id || '-1'"
          [isSubmitting]="false"
          [showApproveDocumentButton]="shouldShowhowApproveDocumentButton"
          [showTerm]="true"
          [allowToAddNewFile]="getIsAllowedToAddFiles()"
          [type]="topicFileType" />
      </div>
    </div>
    <div>
      <div class="lna-row full-width">
        <hr />
        <div class="label-wrapper">
          <label class="form-label lna" for="requiresRestrictedAccess">
            {{ 'pages.researchTopic.requiresRestrictedAccess' | translate }}
          </label>
          @if (fromServiceSummary){<app-tooltip text="requiresRestrictedAccess" />}
          @if (getIsAllowedToAddFiles() && !topic.requiresRestrictedAccess) {
            <app-requires-restricted-access-modal [topic]="topic" (save)="onRestrictedAccessChange($event)" />
          }
        </div>
        <div class="radio-buttons">
          <div class="radio-wrapper">
            <input id="yes" [(ngModel)]="topic.requiresRestrictedAccess" [value]="true" [disabled]="true" type="radio" />
            <label for="active">
              {{ 'components.form.yes' | translate }}
            </label>
          </div>
          <div class="radio-wrapper">
            <input id="no" [(ngModel)]="topic.requiresRestrictedAccess" [value]="false" [disabled]="true" type="radio" />
            <label for="inactive">
              {{ 'components.form.no' | translate }}
            </label>
          </div>
        </div>
      </div>
      @if (topic.requiresRestrictedAccess) {
        <div class="lna-row full-width">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.restrictedAccessJustification' | translate }}
            </p>
            <p class="form-value full-width">
              {{ topic.restrictedAccessJustification || '-' }}
            </p>
          </div>
        </div>
        <div class="lna-row full-width">
          <div class="value-wrapper">
            <div class="label-wrapper">
              <p class="form-label">
                {{ 'pages.client.readersCard.addedFiles' | translate }}
              </p>
              @if (fromServiceSummary){<app-tooltip text="restrictedAccessJustificationFiles" />}
            </div>
            <app-file-upload
              [isEditMode]="false"
              [existingFiles]="getJustificationFiles() || []"
              [associatedEntityId]="topic.id || '-1'"
              [isSubmitting]="false"
              [showApproveDocumentButton]="shouldShowhowApproveDocumentButton"
              [showTerm]="true"
              [type]="justificationFileType"
              [allowToAddNewFile]="getIsAllowedToAddFiles()" />
          </div>
        </div>
      }
    </div>
  </div>
</div>
